export default [
    {
        path: "person_center",
        name: "PersonCenter",
        component: ()=> import('./PersonCenter.vue')
    }
];
